import { PageSection, PageWrapper } from '@src/components';
import { ROUTE_PACKAGE_FULL_URL } from '@src/constants/URLS.const';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Region } from '@src/services/region/regionApiSliceTypes';
import { Button } from 'antd';

interface CountryListProps {
  region: Region;
}

export const CountryList: FC<CountryListProps> = ({ region }) => {
  const navigate = useNavigate();

  const countryNames = region.countries?.map((c) => c.name).join(' · ') || '';

  const handleViewPackages = () => {
    navigate(`${ROUTE_PACKAGE_FULL_URL}?regionId=${region.id}`);
  };
  return (
    <PageWrapper>
      <PageSection className='bg-wl-background mb-4 px-4 py-6 space-y-4 text-wl-on-background'>
        <div className='text-M-16'>Countries covered</div>
        <div className='text-R-16'>{countryNames}</div>
      </PageSection>
      <Button className='btn-primary w-full' onClick={handleViewPackages}>
        View Packages
      </Button>
    </PageWrapper>
  );
};
